// components/industry-templates/EnvironmentEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Leaf, Trees, Droplet, Wind } from 'lucide-react';

export const EnvironmentEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      <Card className="border-0 bg-gradient-to-br from-green-600/20 to-emerald-600/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <Leaf className="w-8 h-8" style={{ color: theme.primary }} />
            Environmental Conservation
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            {industryData?.conservation_projects?.map((project: any, idx: number) => (
              <div key={idx} className="p-5 bg-white/10 rounded-xl">
                <h3 className="text-xl font-bold text-white mb-2">{project.name}</h3>
                <p className="text-slate-300 text-sm mb-3">{project.description}</p>
                <Badge style={{ backgroundColor: theme.primary }}>{project.impact}</Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
